import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as lib from '~/dependencies';
import * as actions from '~/store/actions';

export default function PrivateRoute({ component: Component, ...rest }) {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state.auth && state.auth.token);

  useEffect(() => {
    dispatch(actions.authCheckState());
  }, [dispatch]);

  return (
    <lib.Route
      {...rest}
      render={props =>
        isAuthenticated ? <Component {...props} /> : <lib.Redirect to="/auth" />
      }
    />
  );
}

PrivateRoute.propTypes = {
  component: lib.PropTypes.elementType.isRequired,
};
